import React, { useEffect, useState } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import "../../styles/App.css";
import { NO_GROUP_TEXT } from "../../components/GroupLabel.js";

const StudentRatingPage = () => {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [ratingList, setRatingList] = useState([]);
  const [newRating, setNewRating] = useState({
    points: 0,
    description: "",
    file_url: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    fetchStudents();
  }, []);

  useEffect(() => {
    if (selectedStudent) {
      fetchRating(selectedStudent);
    }
  }, [selectedStudent]);

  const fetchStudents = async () => {
    try {
      const response = await fetch(`${API}/api/students`, {
        headers: { Authorization: getAuthHeader() },
      });
      if (response.ok) {
        const data = await response.json();
        setStudents(data);
      } else {
        alert("Не вдалося завантажити список студентів.");
      }
    } catch (error) {
      console.error("Помилка завантаження студентів:", error);
    }
  };

  const fetchRating = async (studentId) => {
    try {
      const response = await fetch(`${API}/api/rating/${studentId}`, {
        headers: { Authorization: getAuthHeader() },
      });
      if (response.ok) {
        const data = await response.json();
        setRatingList(data);
      } else {
        alert("Не вдалося завантажити рейтинг.");
      }
    } catch (error) {
      console.error("Помилка завантаження рейтингу:", error);
    }
  };

  const handleAddRating = async () => {
    if (
      !selectedStudent ||
      newRating.points < 0 ||
      newRating.description.trim() === ""
    ) {
      alert(
        "Оберіть студента, введіть опис та коректну кількість балів (не менше 0)!"
      );
      return;
    }

    try {
      const response = await fetch(`${API}/api/rating`, {
        method: "POST",
        headers: {
          Authorization: getAuthHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          student_id: selectedStudent,
          points: newRating.points,
          description: newRating.description,
          file_url: newRating.file_url || null,
        }),
      });

      if (response.ok) {
        alert("Рейтинг успішно додано.");
        setNewRating({ points: 0, description: "", file_url: "" });
        fetchRating(selectedStudent);
      } else {
        alert("Не вдалося додати рейтинг.");
      }
    } catch (error) {
      console.error("Помилка додавання рейтингу:", error);
    }
  };

  const filteredStudents = students.filter(
    (student) =>
      student.pib.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (student.group || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSort = (field) => {
    const newOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newOrder);

    const sorted = [...ratingList].sort((a, b) => {
      if (a[field] < b[field]) return newOrder === "asc" ? -1 : 1;
      if (a[field] > b[field]) return newOrder === "asc" ? 1 : -1;
      return 0;
    });
    setRatingList(sorted);
  };

  return (
    <div className="page-container">
      <h2 className="text-header">Управління рейтингом студентів</h2>
      <div className="form-container">
        <input
          className="input-block input-component"
          type="text"
          placeholder="Пошук за ПІБ"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select
          className="input-block input-component"
          value={selectedStudent}
          onChange={(e) => setSelectedStudent(e.target.value)}
        >
          <option value="">Оберіть студента</option>
          {filteredStudents.map((student) => (
            <option key={student.id} value={student.id}>
              {student.pib} ({student.group || NO_GROUP_TEXT})
            </option>
          ))}
        </select>
      </div>
      <h2 className="text-header">Додати новий рейтинг/бали студенту</h2>

      <div className="input-component">
        <div className="form-container">
          <form className="form-container">
            <label className="input-block text-header">
              Бал:
              <input
                className="input-component-with-border"
                type="number"
                placeholder="Кількість балів"
                value={newRating.points}
                min="0"
                onChange={(e) =>
                  setNewRating({
                    ...newRating,
                    points: Math.max(0, Number(e.target.value)),
                  })
                }
              />
            </label>

            <label className="input-block text-header">
              Опис:
              <textarea
                className="input-component-with-border"
                placeholder="Опис (обов'язково)"
                value={newRating.description}
                onChange={(e) =>
                  setNewRating({ ...newRating, description: e.target.value })
                }
              />
            </label>

            <label className="input-block text-header">
              Посилання на файл:
              <input
                className="input-component-with-border"
                type="text"
                placeholder="Посилання на файл (опціонально)"
                value={newRating.file_url}
                onChange={(e) =>
                  setNewRating({ ...newRating, file_url: e.target.value })
                }
              />
            </label>
          </form>
        </div>
      </div>
      <button onClick={handleAddRating} className="submit-button">
        Додати рейтинг
      </button>
      <div>
        {ratingList.length > 0 ? (
          <>
            <h2 className="text-header">Рейтинг студента</h2>
            <table className="table">
              <tr>
                <th
                  className="table-header"
                  onClick={() => handleSort("points")}
                >
                  Кількість балів{" "}
                  {sortField === "points"
                    ? sortOrder === "asc"
                      ? "↑"
                      : "↓"
                    : "↑↓"}
                </th>
                <th
                  className="table-header"
                  onClick={() => handleSort("description")}
                >
                  Опис{" "}
                  {sortField === "description"
                    ? sortOrder === "asc"
                      ? "↑"
                      : "↓"
                    : "↑↓"}
                </th>
                <th className="table-header">Посилання</th>
              </tr>
              {ratingList.map((rating) => (
                <tr>
                  <td className="table-content">{rating.points}</td>
                  <td className="table-content">{rating.description}</td>
                  <td className="table-content">
                    {rating.file_url && (
                      <a
                        href={rating.file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Файл
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </table>
          </>
        ) : (
          <h2 className="text-header">У студента поки немає заслуг</h2>
        )}
      </div>
    </div>
  );
};

export default StudentRatingPage;
